import axiosInstance from "../../../../api/axiosConfig";

export const getSampleProducts = (params: any) => {
  return axiosInstance.get("/admin/sample-products", {
    params: params,
  });
};

export const addUserPersonalizedSampleProducts = (data: any) => {
  return axiosInstance.post("/admin/personalized-users", data);
};
